import { Spin } from 'antd';
import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import styled, { ITheme } from 'styled-components';

interface IBTNProps {
    title: string;
    onClick: () => void;
    className?: string;
    loading?: boolean;
    icon?: () => any;
}
const antIcon = <LoadingOutlined className="pin-icon" style={{ fontSize: 24 }} spin />;

const Button = styled.button`
    cursor: pointer;
    background: #141414;
    border: 1px solid ${({ theme }: { theme: ITheme }) => theme.border1};
    border-radius: 4px;
    padding: 12px 24px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
        margin-right: 8px;
    }
    :disabled {
        opacity: 0.5;
        &:hover {
            cursor: pointer;
            transform: scale(1);
        }
    }
    .pin {
        margin-left: 20px;
    }
    .pin-icon {
        color: ${({ theme }: { theme: ITheme }) => theme.white};
    }

    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
    `}
`;
export default function ButtonOutline(props: IBTNProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {
    const { title, icon, onClick, loading, className, ...rest } = props;

    return (
        <Button type="button" className={`fw-bold fs-regular ${className}`} onClick={onClick} {...rest}>
            {icon && icon()}
            {title}
            {!!loading && <Spin className="pin" indicator={antIcon} />}
        </Button>
    );
}
